import React, { Component } from "react";
import { connect } from "react-redux";
import { createNewCheckout, refreshOfferTimeout, resetOfferTimeout, toggleModal } from "../actions";
import {
	combinedFlightsHasDifferentCheaperPricings,
	stretchesHasSameCompanies,
	oneIsNotAvailableInMiles,
	setCheaperPriceData,
	$,
	formatCurrency,
	bestMaxMilhasPrice
} from "../shared/utils";
import SessionTimeWrapper from "./SessionTimeWrapper";
import FlightSelected from "./FlightSelected";
import FlightBillingResume from "./FlightBillingResume";
import BenefitsCard from "./BenefitsCard";
import RedirectAirlineModal from "./RedirectAirlineModal";
import { OPEN_MODAL, CLOSE_MODAL } from "../shared/constants";
import PubSub from "pubsub-js";
import getURLParams from "../shared/getURLParams";
import { IS_PROD } from "../shared/constants";

let isTypePassageFiltered = sessionStorage.getItem("p") && ((IS_PROD && location.host === "www.maxmilhas.com.br") || !IS_PROD);

class Checkout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			redirectModalOpen: true,
			outboundPricing: props.selectedFlights.outbound[0].pricing,
			inboundPricing: props.selectedFlights.inbound[0]
				? props.selectedFlights.inbound[0].pricing
				: null,
			priceChange: null
		};

		this.closeRedirectModal = this.closeRedirectModal.bind(this);

		if (sessionStorage.getItem("p") && sessionStorage.getItem("p").indexOf("_") > -1) {
			isTypePassageFiltered = false;
		}
	}

	componentWillReceiveProps(nextProps) {
		let outboundDiff, inboundDiff;

		if (
			nextProps.selectedFlights.outbound.length > 0 &&
			nextProps.selectedFlights.outbound[0].otaAvailableIn !== "airline"
		) {
			const bestOutbound = bestMaxMilhasPrice(nextProps.selectedFlights.outbound[0].pricing);

			if (bestOutbound.changedValue) {
				outboundDiff = bestOutbound.valueDiference;
			}
		}

		if (
			nextProps.selectedFlights.inbound.length > 0 &&
			nextProps.selectedFlights.inbound[0].otaAvailableIn !== "airline"
		) {
			const bestInbound = bestMaxMilhasPrice(nextProps.selectedFlights.inbound[0].pricing);

			if (bestInbound.changedValue) {
				inboundDiff = bestInbound.valueDiference;
			}
		}

		if (outboundDiff || inboundDiff) {
			this.setState({
				priceChange: {
					outboundDiff: outboundDiff || undefined,
					inboundDiff: inboundDiff || undefined
				}
			});
		}
	}

	hasFlightsFromDifferentCompanies() {
		if (!this.props.selectedFlights) return false;

		const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;

		if (inboundFlight.length > 0 && outboundFlight.length > 0)
			return inboundFlight[0].airline !== outboundFlight[0].airline;

		return false;
	}

	/**
	 * Habilita o botão `comprar apenas {stretch} na {cia aérea/maxmilhas}`
	 * quando os trechos não pertencerem às mesmas companhias e quando
	 * o preço mais barato de cada trecho for diferente um do outro (um milhas,
	 * outro airline, por exemplo)
	 */
	shouldEnableAlternativeSearch() {
		const { inbound: inboundFlight, outbound: outboundFlight } = this.props.selectedFlights;
		const tripType = this.props.triptype;

		if (tripType === "RT" && (inboundFlight.length <= 0 || outboundFlight.length <= 0)) {
			return;
		}

		const airlineHasCheaperPriceOutbound = setCheaperPriceData(outboundFlight[0].pricing)
			.airlineHasCheaperPrice;
		let airlineHasCheaperPriceInbound;

		if (tripType === "OW") {
			return false;
		} else {
			airlineHasCheaperPriceInbound = setCheaperPriceData(inboundFlight[0].pricing)
				.airlineHasCheaperPrice;
		}

		return (
			combinedFlightsHasDifferentCheaperPricings([outboundFlight[0], inboundFlight[0]]) ||
			(!stretchesHasSameCompanies([outboundFlight[0], inboundFlight[0]]) &&
				(airlineHasCheaperPriceOutbound || airlineHasCheaperPriceInbound)) ||
			oneIsNotAvailableInMiles([outboundFlight[0], inboundFlight[0]])
		);
	}

	componentDidMount() {
		this.props.resetOfferTimeout();
		this.props.refreshOfferTimeout();		

		/** Procura na rota de checkout (hash #checkout) se o param s2 para ABs em api de checkout foi injetado
		 e guarda na sessão do user para usar na criação do checkout */
		setTimeout(() => {
			if (getURLParams(window.location.href).s2) {
				sessionStorage.setItem("s2", "true");
			}
		}, 1000);

		if (this.props.triptype === "RT") {
			if (this.hasFlightsFromDifferentCompanies()) {
				PubSub.publish("dataLayer", {
					event: "gaEvent",
					gaEventCategory: "Pré-checkout",
					gaEventAction: "Selecionou companhias diferentes",
					gaEventLabel: "",
					gaEventValue: ""
				});
			} else {
				PubSub.publish("dataLayer", {
					event: "gaEvent",
					gaEventCategory: "Pré-checkout",
					gaEventAction: "Selecionou companhias iguais",
					gaEventLabel: "",
					gaEventValue: ""
				});
			}
		}

		$(".page-wrapper").classList.add("pre-checkout");
	}

	componentWillUnmount() {
		$(".page-wrapper").classList.remove("pre-checkout");
	}

	closeRedirectModal() {
		$("body").classList.remove("body-lock");
		this.props.closeModal();
	}

	renderAlertPrice() {
		
		if (this.state.priceChange) {
			let diffsFare = 0;
			let stretchs = [];

			if (this.state.priceChange.outboundDiff) {
				stretchs.push("IDA");
				diffsFare += this.state.priceChange.outboundDiff;
			}

			if (this.state.priceChange.inboundDiff) {
				stretchs.push("VOLTA");
				diffsFare += this.state.priceChange.inboundDiff;
			}

			if (this.hasFlightsFromDifferentCompanies()) {
				return (
					<div
						className={
							diffsFare > 0 ? "alert alert-info no-margin-top" : "alert alert-success no-margin-top"
						}
						role="alert"
					>
						<div className="alert--icon">
							<i className={diffsFare > 0 ? "icon-exclamation" : "icon-check"} />
						</div>
						<div className="alert--message">
							{diffsFare > 0 ? (
								<p>
									A compra de passagens de <strong>ida e volta em cias aéreas diferentes</strong>{" "}
									gerou uma variação de preço. O{stretchs.length > 1 && "s"} trecho{stretchs.length >
										1 && "s"}{" "}
									de <strong>{stretchs.join(" E ")}</strong> da sua viagem{" "}
									{stretchs.length === 1 ? "teve" : "tiveram"} alteração de{" "}
									{formatCurrency(Math.abs(diffsFare))}.
								</p>
							) : (
								<p>
									Oba! O{stretchs.length > 1 && "s"} trecho{stretchs.length > 1 && "s"} de{" "}
									<strong>{stretchs.join(" E ")}</strong> da sua viagem{" "}
									{stretchs.length === 1 ? "ficou" : "ficaram"}{" "}
									<strong>{formatCurrency(Math.abs(diffsFare))}</strong> mais barato{stretchs.length >
										1 && "s"}{" "}
									do que no momento da busca.
								</p>
							)}
						</div>
					</div>
				);
			} else {
				return (
					<div className="alert alert-info no-margin-top" role="alert">
						<div className="alert--icon">
							<i className="icon-exclamation" />
						</div>
						<div className="alert--message">
							<p>
								Os preços selecionados não estão disponíveis para essa combinação de voos e os
								valores foram atualizados. Caso prefira, refaça o processo selecionando novas
								opções.
							</p>
						</div>
					</div>
				);
			}
		}
	}

	render() {				
		const { selectedFlights: { outbound: [firstOutbound], inbound: [firstInbound] } } = this.props;
		const isMiles = flight =>
			flight
				? flight.otaAvailableIn !== "airline" && flight.pricing.mmBestPriceAt === "miles"
				: false;

		const isOnlyInMiles = isMiles(firstOutbound) && (firstInbound ? isMiles(firstInbound) : true);

		const isExclusiveCompany =
			firstOutbound.otaAvailableIn === "airline" ||
			(firstInbound && firstInbound.otaAvailableIn === "airline");

		return (
			<div className="checkoutpage" data-flight-onlymiles={isOnlyInMiles}>
				<section className="container-fluid">
					<div className="general-info">
						<h3 className="lead">Confirme seus voos</h3>
						{(!isExclusiveCompany && !isTypePassageFiltered) && <SessionTimeWrapper />}						
					</div>

					<div className="row">
						<div className="col-xs-16 col-md-12">
							{this.renderAlertPrice()}
							<FlightSelected
								key={`checkout_outbound`}
								flightdata={
									this.props.selectedFlights ? this.props.selectedFlights.outbound[0] : null
								}
								enableAlternativeSearch={this.shouldEnableAlternativeSearch()}
								enableSelectOtherFlight={true}
								flighType={"outbound"}
							/>

							<FlightSelected
								key={`checkout_inbound`}
								flightdata={
									this.props.selectedFlights ? this.props.selectedFlights.inbound[0] : null
								}
								enableAlternativeSearch={this.shouldEnableAlternativeSearch()}
								enableSelectOtherFlight={true}
								flighType={"inbound"}
							/>
						</div>
						<div className="col-xs-16 col-md-4">
							<div className="checkout-wrapper">
								<FlightBillingResume />
								<BenefitsCard />
							</div>
						</div>
					</div>
				</section>
				<div className={`tingle-modal no-padding ${this.props.isOpen ? "tingle-modal--visible" : ""}`}>
					<RedirectAirlineModal
						open={this.state.redirectModalOpen}
						closeModal={this.closeRedirectModal}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	selectedFlights: state.selectedFlights,
	triptype: state.searchParams.params.tripType,
	isOpen: state.modal.isOpen
});

const mapDispatchToProps = dispatch => {
	return {
		createCheckout: createCheckoutData => dispatch(createNewCheckout(createCheckoutData)),
		refreshOfferTimeout: () => dispatch(refreshOfferTimeout()),
		resetOfferTimeout: () => dispatch(resetOfferTimeout()),
		openModal: () => dispatch(toggleModal(OPEN_MODAL)),
		closeModal: () => dispatch(toggleModal(CLOSE_MODAL))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
